function initBundleVariantPickers() {
  document.querySelectorAll('.bundle-item').forEach((item) => {
    const variantDataEl = item.querySelector('[type="application/json"]');
    if (!variantDataEl) return;

    let variantData;
    try {
      const parsed = JSON.parse(variantDataEl.textContent);
      variantData = parsed.variants || parsed;
    } catch (err) {
      console.error('[BUNDLE] Invalid variant JSON:', err);
      return;
    }

    if (!Array.isArray(variantData)) {
      console.error('[BUNDLE] No valid variant data found:', variantData);
      return;
    }

    item._variantData = variantData;

    const form = item.closest('form');
    const addBtn = form?.querySelector('.add-to-bundle');
    const selectors = item.querySelectorAll('.option-selector');
    const picker = item.querySelector('bundle-variant-picker');

    if (!form || !addBtn || !selectors.length) return;

    function getSelectedOptions() {
      return Array.from(selectors).map((selector) => {
        const selected = selector.querySelector('.custom-select__option[aria-selected="true"]');
        return selected ? selected.dataset.value : null;
      });
    }

    function updateVariantSelection() {
      const selectedOptions = getSelectedOptions();

      if (!selectedOptions || selectedOptions.includes(null)) {
        console.warn('[BUNDLE] Incomplete selected options:', selectedOptions);
        return;
      }

      const matchedVariant = variantData.find((v) =>
        v.options.every((val, i) => val === selectedOptions[i])
      );

      console.log('[BUNDLE] Selected Options:', selectedOptions);
      console.log('[BUNDLE] Matched Variant:', matchedVariant);

      const input = form.querySelector('[name="id"]');
      if (!input) return;

      if (matchedVariant) {
        input.value = matchedVariant.id;
        addBtn.disabled = !matchedVariant.available;
        addBtn.textContent = matchedVariant.available ? addBtn.dataset.textAdd : 'Sold Out';

        // Update bundle-item dataset so other scripts like bundle-builder.js can use it
        item.dataset.variantId = matchedVariant.id;
        item.dataset.price = matchedVariant.price / 100;
        item.dataset.options = selectedOptions.join(' · ');

        const event = new CustomEvent('bundle:variant:change', {
          bubbles: true,
          detail: {
            variant: matchedVariant,
            selectedOptions: selectedOptions
          }
        });

        picker?.dispatchEvent(event);
      } else {
        input.value = '';
        addBtn.disabled = true;
        addBtn.textContent = 'Select Variant';
      }
    }

    // Attach change event listeners
    selectors.forEach((selector) => {
      const customSelect = selector.querySelector('custom-select');
      if (customSelect) {
        console.log('[BUNDLE] attaching listener to:', customSelect);
        customSelect.addEventListener('change', updateVariantSelection);
      } else {
        console.warn('[BUNDLE] customSelect not found in:', selector);
      }
    });

    // Ensure one default option is selected and trigger change
    selectors.forEach((selector) => {
      const customSelect = selector.querySelector('custom-select');
      if (customSelect) {
        const options = customSelect.querySelectorAll('.custom-select__option');
        const hasSelected = Array.from(options).some(opt => opt.getAttribute('aria-selected') === 'true');

        if (!hasSelected && options.length > 0) {
          options[0].setAttribute('aria-selected', 'true');
        }

        // Trigger change after delay to ensure listeners are attached
        setTimeout(() => {
          customSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }, 0);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (customElements.get('custom-select')) {
    initBundleVariantPickers();
  } else {
    customElements.whenDefined('custom-select').then(() => {
      initBundleVariantPickers();
    });
  }
});
